// frontend/src/components/parent/WeeklyReportCard.tsx
// Günlük / Haftalık / Aylık rapor sekme sistemi

import { ReportPeriod, ActivityReport } from '../../types/parent.types';

interface ReportTabBarProps {
  activeTab: ReportPeriod;
  onChange: (tab: ReportPeriod) => void;
}

export function ReportTabBar({ activeTab, onChange }: ReportTabBarProps) {
  const tabs: { value: ReportPeriod; label: string }[] = [
    { value: 'daily', label: 'Bugün' },
    { value: 'weekly', label: 'Bu Hafta' },
    { value: 'monthly', label: 'Bu Ay' },
  ];

  return (
    <div className="pcd-tab-bar" role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.value}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.value}
          className={`pcd-tab-btn ${activeTab === tab.value ? 'active' : ''}`}
          onClick={() => onChange(tab.value)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

interface PeriodSummaryCardProps {
  report: ActivityReport | null;
  isLoading: boolean;
}

export function PeriodSummaryCard({ report, isLoading }: PeriodSummaryCardProps) {
  if (isLoading) {
    return (
      <div className="pcd-period-summary">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="pcd-period-item pcd-skeleton-item" />
        ))}
      </div>
    );
  }

  if (!report) return null;

  const items = [
    { label: 'Ders', value: report.lessonsCompleted },
    { label: 'Quiz', value: report.quizzesSolved },
    { label: 'Proje', value: report.projectsSubmitted },
    { label: 'AI Sohbet', value: report.aiChats },
    { label: 'Aktif Gün', value: report.activeDays },
    { label: 'Kazanılan XP', value: report.xpEarned.toLocaleString('tr-TR') },
  ];

  return (
    <div className="pcd-period-summary">
      {items.map((item) => (
        <div key={item.label} className="pcd-period-item">
          <span className="pcd-period-value">{item.value}</span>
          <span className="pcd-period-label">{item.label}</span>
        </div>
      ))}
    </div>
  );
}
